import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
//import moment from 'moment';

import GreenChecked from '../../../images/icons/greenChecked.svg';
import { getCommodityCodeToDisplay } from '../common/commodities';
import { isLocalhost } from '../../../util';

export const STL_BLUE = '#1289d4';

export const generalStyles = {
	productContainer: {
		fontSize: '120%',
		marginTop: 5,
	},
	productTitle: {
		marginTop: '4vw',
		textTransform: 'uppercase',
		color: '#999',
		fontWeight: 200,
		letterSpacing: 2,
		borderBottom: '1px solid #ccc',
	},
	product: {
		//borderBottom: '1px solid #eee',
		width: '100%',
		boxSizing: 'border-box',
		alignItems: 'center',
		lineHeight: 1.3,
		marginTop: 0,
		paddingTop: 5,
		marginBottom: 5,
		paddingBottom: 5,
	},

	productStopTitle: {
		fontWeight: 700,
		marginTop: 10,
	},
	productStopGrouping: {
		borderLeft: `4px solid #ddd`,
		marginLeft: 12,
		paddingLeft: 10,
	},

	commodityFormLabel: {
		fontSize: '90%',
		textTransform: 'uppercase',
		color: '#222',
		fontWeight: 900,
	},

	commodityFormProductGroup: {
		//borderBottom: '1px solid #eee',
		width: '100%',
		boxSizing: 'border-box',
		alignItems: 'center',
		lineHeight: 1.3,
		marginTop: 0,
		paddingTop: '.5vw',
		marginBottom: '4vw',
		borderLeft: `4px solid #ddd`,
		paddingLeft: '1vw',
	},

	commodityFormProductAttribute: {
		marginTop: '.5vw',
	},

	commodityFormProductInput: {
		display: 'flex',
		marginTop: '2vw',
	},

	greenCheckedIcon: {
		display: 'inline-block',
		width: '4.5vw',
		height: '4.5vw',
		backgroundImage: `url('${GreenChecked}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
		marginLeft: 5,
	},
};

export function groupCommodities({ commodities, stopNumber }) {
	const comByStopSeq = {};
	for (const commodity of commodities) {
		if (stopNumber && commodity.stopNumber !== stopNumber) {
			continue;
		}

		const stopSequence = commodity.stopSequence;
		if (!comByStopSeq[stopSequence]) {
			comByStopSeq[stopSequence] = {
				stopSequence,
				consigneeId: commodity.consigneeId,
				commodities: [],
			};
		}
		comByStopSeq[stopSequence].commodities.push(commodity);
	}
	const hasMultipleDrops = _.keys(comByStopSeq).length > 1;

	const commoditiesByStop = _.keys(comByStopSeq)
		.sort()
		.map((key) => {
			const comByStop = comByStopSeq[key];
			return {
				stopSequence: comByStop.stopSequence,
				consigneeId: comByStop.consigneeId,
				commodities: _.orderBy(comByStop.commodities, ['stopSequence', 'cmdCode']),
			};
		});

	return {
		hasMultipleDrops,
		commoditiesByStop,
	};
}

export class MobileDeliveryCommodityProduct extends Component {
	render() {
		const { cmdCode } = this.props;
		if (!cmdCode) {
			return null;
		}
		const cmd = getCommodityCodeToDisplay(cmdCode);
		return (
			<span
				style={{
					borderRadius: 20,
					backgroundColor: cmd.bg,
					color: 'white',
					padding: '3px 12px',
					fontSize: '90%',
					fontWeight: 1000,
					textTransform: 'uppercase',
					marginRight: '1vw',
					marginBottom: '1vw',
				}}
			>
				{cmd.abbr}
			</span>
		);
	}
}

MobileDeliveryCommodityProduct.propTypes = {
	cmdCode: PropTypes.string.isRequired,
};

const eventTypeToDisplay = {
	PUP: 'Pick Up',
	DRP: 'Drop',
	BMT: 'Start',
};

export function convertEventTypeToDisplay(eventType) {
	if (eventTypeToDisplay[eventType]) {
		return eventTypeToDisplay[eventType];
	} else {
		return eventType;
	}
}

export const toNum = (v) => {
	return _.isNumber(v) ? v.toLocaleString('en-US') : '';
};

// ~~~~ Stops

const STATUS_BLUE = '#1289d4';
const STATUS_GREEN = '#43A047';

export const STOP_STATUS = {
	OPN: 'OPN',
	DNE: 'DNE',
	ARRIVED: 'ARRIVED',
};

const STOP_STATUS_DISPLAY = {
	[STOP_STATUS.OPN]: 'Open',
	[STOP_STATUS.DNE]: 'Done',
	[STOP_STATUS.ARRIVED]: 'Arrived',
};

const STOP_STATUS_STYLE = {
	[STOP_STATUS.OPN]: {
		borderLeft: `1px solid ${STATUS_BLUE}`,
		borderRight: `1px solid ${STATUS_BLUE}`,
		color: STATUS_BLUE,
	},
	[STOP_STATUS.ARRIVED]: {
		border: `1px solid ${STATUS_BLUE}`,
		backgroundColor: STATUS_BLUE,
		color: 'white',
	},
	[STOP_STATUS.DNE]: {
		border: `1px solid ${STATUS_GREEN}`,
		backgroundColor: STATUS_GREEN,
		color: 'white',
	},
};

const STOP_STATUS_BADGE_STYLE = {
	[STOP_STATUS.OPN]: {
		border: `1px solid ${STATUS_BLUE}`,
		color: STATUS_BLUE,
	},
	[STOP_STATUS.ARRIVED]: {
		border: `1px solid ${STATUS_BLUE}`,
		backgroundColor: STATUS_BLUE,
		color: 'white',
	},
	[STOP_STATUS.DNE]: {
		border: `1px solid ${STATUS_GREEN}`,
		backgroundColor: STATUS_GREEN,
		color: 'white',
	},
};

function getCombinedStatus(stopStatus, stopDepartureStatus) {
	if (!stopDepartureStatus) {
		return stopStatus;
	} else if (stopStatus === stopDepartureStatus) {
		return stopStatus;
	} else {
		// Arrived but have not departed
		if (stopStatus === STOP_STATUS.DNE && stopDepartureStatus === STOP_STATUS.OPN) {
			return STOP_STATUS.ARRIVED;
		} else {
			return STOP_STATUS.DNE;
		}
	}
}

export function stopStatusToStyle(stopStatus, stopDepartureStatus) {
	const combinedStatus = getCombinedStatus(stopStatus, stopDepartureStatus);
	return STOP_STATUS_STYLE[combinedStatus] || { backgroundColor: 'gray', color: 'white' };
}
export function stopStatusToBadgeStyle(stopStatus, stopDepartureStatus) {
	const combinedStatus = getCombinedStatus(stopStatus, stopDepartureStatus);
	return STOP_STATUS_BADGE_STYLE[combinedStatus] || { backgroundColor: 'gray', color: 'white' };
}

export function stopStatusToDisplay(stopStatus, stopDepartureStatus) {
	const combinedStatus = getCombinedStatus(stopStatus, stopDepartureStatus);
	if (!STOP_STATUS_DISPLAY[combinedStatus]) {
		console.log('Missing stop status', combinedStatus);
	}
	return STOP_STATUS_DISPLAY[combinedStatus] || 'Unknown';
}

// ~ override

const testUserId = sessionStorage.getItem('testMobile-testUserId') || '';
const testOverrideShiftDate = sessionStorage.getItem('testMobile-overrideShiftDate') || '';

// local overload for testing
// const LAUAL_USER_ID = 185;

let localOverrideUserId;
let localOverrideShiftDate;
if (isLocalhost) {
	//localOverrideUserId = LAUAL_USER_ID;
	//localOverrideShiftDate = '2023-04-11';
	//const PANAL_USER_ID = 251;
	//localOverrideUserId = 803;
	//localOverrideShiftDate = '2024-01-20';

	localOverrideUserId = 303;
	localOverrideShiftDate = '2024-03-02';
	//const BRAAL_USER_ID = 419;
	//localOverrideUserId = LAUAL_USER_ID; // ;
	//localOverrideUserId = 125;
	//localOverrideShiftDate = '2023-05-22';
}

export const LAUAL_USER_ID = 185;
export const DWP_USER_ID = 1;
export function canUseScanFeature(userId) {
	return LAUAL_USER_ID === userId || userId === DWP_USER_ID;
}

/*
const MARK_CANNON_ID = 541;

export function isBetaUser(userId) {
	return _.includes(
		[
			LAUAL_USER_ID,
			MARK_CANNON_ID,
			DELIS_ID,
			HALBE_ID,
			FARSA_ID,
			GONDA01_ID,
			CASRI_ID,
			DAVDA_ID,
			AMMDA_ID,
			BOGRI_UD,
			GRIJA_ID,
			WARED_ID,
			YOSJO_ID,
			LARJO_ID,
			FLYRO_ID,
			ERWJA_ID,
			GIBRO_ID,

			CHEMY_ID,
			SUCLU_ID,
			RODMA_ID,
			CABOC_ID,
			THOST_ID,
			SOUKR_ID,
			BAEGU_ID,
			SERMA_ID,
			HUNMI_ID,
			DOMGU_ID,
			CERVI_ID,
			GONED_ID,
			RAMHU_ID,
			LUTMU_ID,
		],
		userId
	);
}
*/

export function getOverrideParams(authUserId) {
	const params = {};

	if (testUserId) {
		params.overrideUserId = parseInt(testUserId, 10);
	}

	if (testOverrideShiftDate) {
		params.overrideShiftDate = testOverrideShiftDate;
	}

	if (localOverrideUserId) {
		params.overrideUserId = localOverrideUserId;
		params.overrideShiftDate = localOverrideShiftDate;
	}

	// For production OVERRIDE_LAUAL
	if (authUserId && authUserId === DWP_USER_ID) {
		params.overrideUserId = 22;
		//params.overrideUserId = 128;
		params.overrideShiftDate = '2024-03-16';
	}
	return params;
}

export const LEG_OUT_STATUS = {
	PLN: 'PLN',
	UNP: 'UNP',
	STD: 'STD',
	CMP: 'CMP',
};

export const ENTER_TIME_EVENT_TYPE = {
	ARRIVAL: 'ARRIVAL',
	DEPARTURE: 'DEPARTURE',
};
